import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import manualIdVerificationService from '../../../../services/manualidverification/ManualIdVerificationService';

import PreCheckAction from '../preChecks/PreCheckAction';
import ManualIdVerificationRejected from './ManualIdVerificationRejected';
import ManualIdVerificationPending from './ManualIdVerificationPending';
import testComponentManualIdVerificationSelector from
    '../../../../selectors/testOverview/testComponents/manualidverification/TestComponentManualIdVerificationSelector';
import idVerificationService from '../../../../services/idverification/IdVerificationService';

class TestComponentManualIdVerification extends React.PureComponent {
    static propTypes = {
        completed: PropTypes.bool.isRequired,
        current: PropTypes.bool.isRequired,
        rejected: PropTypes.bool.isRequired,
        shouldBeHighlightedAsFailed: PropTypes.bool.isRequired,
        shouldNavigateToPhotoRetake: PropTypes.bool.isRequired,
        shouldRequestManualIdCheck: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
    };

    componentDidMount() {
        const { shouldRequestManualIdCheck } = this.props;
        // When coming from Automated ID Check full-page and back into Test_Overview_GUI, thus re-mounted.
        if (shouldRequestManualIdCheck) {
            manualIdVerificationService.requestManualIdVerification();
        }
    }

    componentDidUpdate(prevProps) {
        const { current, shouldRequestManualIdCheck, shouldNavigateToPhotoRetake } = this.props;
        const retakePhotoStatusChanged = prevProps.shouldNavigateToPhotoRetake !== shouldNavigateToPhotoRetake;
        const currentChanged = prevProps.current !== current;

        if (retakePhotoStatusChanged && shouldNavigateToPhotoRetake) {
            idVerificationService.gotoPhotoRetake();
        } else if (currentChanged && shouldRequestManualIdCheck) {
            manualIdVerificationService.requestManualIdVerification();
        }
    }

    render() {
        const {
            completed,
            current,
            rejected,
            title,
            shouldBeHighlightedAsFailed,
        } = this.props;

        return (
            <PreCheckAction
                current={current}
                completed={completed}
                failed={shouldBeHighlightedAsFailed}
                title={title}
            >
                { rejected
                    ? <ManualIdVerificationRejected />
                    : <ManualIdVerificationPending />
                }
            </PreCheckAction>
        );
    }
}

const mapStateToProps = state => testComponentManualIdVerificationSelector.computeProps(state);

export default connect(mapStateToProps)(TestComponentManualIdVerification);
